import styles from "./Start.module.css";
import hberufsfachschule from "./assets/hberufsfachschule.PNG";

const Start = () => {
    return(
       <>
                      <div
                          className={styles.hero}
                          style={{ backgroundImage: `url(${hberufsfachschule})` }}
                      >

                      </div>
        <main className="wrapper">
            <section className="wrapperContent">
                <div className={styles.text}>
                    <h1>Die Zweijährige Höhere Berufsfachschule (HBFS)</h1>
                    <p>Die zweijährige höhere Berufsfachschule (Assistentenberufe) bietet Schülerinnen und Schülern mit mittlerem Abschluss eine Alternative zum dualen Ausbildungssystem. Die Ausbildung schließt mit einer staatlichen Prüfung ab, die eine Berufsbezeichnung als „Assistent/in“ verleiht. Absolventinnen und Absolventen der zweijährigen höheren Berufsfachschule haben die Möglichkeit, nach erfolgreichem Ablegen einer Hochschulzugangsprüfung in Verbindung mit einer mindestens zweijährigen Berufstätigkeit, ein fachgebundenes Studium an hessischen Hochschulen und Berufsakademien aufzunehmen. Zudem besteht die Möglichkeit, über Zusatzunterricht und eine Zusatzprüfung eine Fachhochschulreife zu erwerben.</p>
                    <p>Nach der zweijährigen vollschulischen Ausbildung ist mit einem vierwöchigen Praktikum und nach der Abschlussprüfung ein direkter Einstieg ins Berufsleben möglich. Die zweijährige höhere Berufsfachschule vermittelt Kenntnisse, Fähigkeiten und Fertigkeiten und befähigt zu verantwortlichem Handeln bei der Mitgestaltung im Beruf und in der Gesellschaft.</p>
                </div>
            </section>
        </main>
        </>

    )

}
export default Start;